module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui three column centered grid"
  }, [_c('div', {
    staticClass: "middle aligned column"
  }, [_c('p', [_vm._v("Find out more "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("about Wikistats")]), _vm._v(" and the "), _c('router-link', {
    attrs: {
      "to": "/about-data"
    }
  }, [_vm._v("data that it uses")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle aligned column"
  }, [_c('p', [_vm._v("Wikistats is written with "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//vuejs.org"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" and "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//semantic-ui.com"
    }
  }, [_vm._v("Semantic UI")]), _vm._v(".  If you'd like to contribute, see our "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//wikitech.wikimedia.org/wiki/Analytics/Wikistats2.0"
    }
  }, [_vm._v("contributing guide")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle aligned column"
  }, [_c('p', [_vm._v("Wikistats is designed by "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//aislinngrigas.com/about/"
    }
  }, [_vm._v("Aislinn Grigas")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "eight wide middle aligned column"
  }, [_c('p', [_vm._v("To the extent possible under law, The Wikimedia Foundation has waived all copyright and related or neighboring rights the data and charts on this site.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3278ed8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomFooter.vue
// module id = 386
// module chunks = 1